import { inputBookInfo, inputPurchaserInfo, selectNoteUrl, selectBookCover } from "./actions";
import { db, FirebaseTimestamp } from "../../firebase/index";
import { push } from "connected-react-router";

export const setNoteUrlToArray = (noteUrl1, noteUrl2, noteUrl3, noteUrl4, noteUrl5, identification, copyright) => {
    var noteUrlArray = []
    return async (dispatch) => {
        if (noteUrl1 !== "") noteUrlArray.push(noteUrl1)
        if (noteUrl2 !== "") noteUrlArray.push(noteUrl2)
        if (noteUrl3 !== "") noteUrlArray.push(noteUrl3)
        if (noteUrl4 !== "") noteUrlArray.push(noteUrl4)
        if (noteUrl5 !== "") noteUrlArray.push(noteUrl5)

        dispatch(selectNoteUrl({
            noteUrl: noteUrlArray,
            identification: identification,
            copyright: copyright,
        }))

        if ( (noteUrl1 !== "") && ((identification === true) || (copyright === true)) ) {
            dispatch(push("/book-settings"))
        }else{
            window.alert("必須項目が入力されていません。")
        }

    }
}

export const setBookInfo = (bookTitle, author) => {
    return async (dispatch) => {
        dispatch(inputBookInfo({
            bookTitle: bookTitle,
            author: author,
        }))

        if ( (bookTitle !== "") && (author !== "")) {
            dispatch(push("/select-book-cover"))
        }else{
            window.alert("必須項目が入力されていません。")
            return false
        }
    }
}

export const setBookCover = (bookCover) => {
    return async (dispatch) => {
        dispatch(selectBookCover({
            bookCover: bookCover
        }))

        if ( bookCover !== "" ) {
            dispatch(push("/input-purchaser-info"))
        }else {
            window.alert("本の表紙が選択されていません。")
            return false
        }
    }
}

export const setPurchaserInfo = (purchaser, furigana, email, birthOfDay, sex, howDidChermoKnow, otherSpecificContent) => {
    return async (dispatch) => {
        dispatch(inputPurchaserInfo({
            purchaser: purchaser,
            furigana: furigana,
            email: email,
            birthOfDay: birthOfDay,
            sex: sex,
            howDidChermoKnow: howDidChermoKnow,
            otherSpecificContent: otherSpecificContent,
        }))

        if ( (purchaser !== "") && (furigana !== "") && (email !== "")) {
            dispatch(push("/input-shipping-info"))
        }else{
            window.alert("必須項目が入力されていません。")
            return false
        }
    }
}

export const registerOrders = (bookTitle, author, bookCover, purchaser, furigana, email, noteUrl, identification, copyright, orderuuid, birthOfDay, sex, howDidChermoKnow, otherSpecificContent) => {
    return async (dispatch) => {
        // validation
        if( bookTitle === "" || author === "" || purchaser === "" || furigana === "" || email === "" || noteUrl.lengh === 0 || (!identification && !copyright) ) {
                alert("必須項目が未入力です")
                return false
        }

        const createdAt = FirebaseTimestamp.now()
        
        const ordersData = {
            orderId: orderuuid,
            bookTitle: bookTitle,
            author: author,
            bookCover: bookCover,
            purchaser: purchaser,
            furigana: furigana,
            email: email,
            noteUrl: noteUrl,
            identification: identification,
            copyright: copyright,
            createdAt: createdAt,
            birthOfDay: birthOfDay,
            sex: sex,
            howDidChermoKnow: howDidChermoKnow,
            otherSpecificContent: otherSpecificContent,
        }

        db.collection('Orders').doc().set(ordersData)
            .then(() => {
                //console.log('success to register orders');
            })
    }
}